import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Box, IconButton, Popover, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '@/contexts/SessionContext';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';
import { getSubdomain } from '@/utils';
// Styled components for better UX
var ProfilePopover = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(3),
        minWidth: 280,
        maxWidth: 320,
    });
});
var ProfileHeader = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderBottom: "1px solid ".concat(theme.palette.divider),
        marginBottom: theme.spacing(2),
    });
});
var ProfileInfo = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadius,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    });
});
var LogoutButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        marginTop: theme.spacing(2),
        justifyContent: 'flex-start',
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
        },
    });
});
export default (function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = _a.innerRef, innerRef = _l === void 0 ? null : _l;
    var navigate = useNavigate();
    var buttonRef = React.useRef(null);
    var _m = React.useState(false), showEndSession = _m[0], setShowEndSession = _m[1];
    var _o = React.useState(null), anchorEl = _o[0], setAnchorEl = _o[1];
    var open = Boolean(anchorEl);
    var _p = React.useState(false), showTour = _p[0], setShowTour = _p[1];
    var _q = useSessionContext(), user = _q.user, onLogout = _q.onLogout, organization = _q.organization;
    console.log(user, organization);
    var handleWaitForBotResponse = function (status) {
        var _a;
        if (status) {
            //@ts-ignore
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
        else {
            setAnchorEl(null);
        }
    };
    React.useImperativeHandle(innerRef, function () { return ({
        //@ts-ignore
        open: function () { var _a; return (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.click(); },
        close: function () { return setAnchorEl(null); }
    }); });
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleLogout = function () {
        onLogout();
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { id: "user-profile", ref: buttonRef, "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, sx: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                }, children: _jsx(Stack, { direction: "row", spacing: 2, children: _jsx(Avatar, { alt: (_b = ((user === null || user === void 0 ? void 0 : user.given_name) || (user === null || user === void 0 ? void 0 : user.name) || 'User')) === null || _b === void 0 ? void 0 : _b.toUpperCase(), src: user === null || user === void 0 ? void 0 : user.picture, sx: {
                            bgcolor: 'primary.main',
                            width: 36,
                            height: 36,
                            border: '2px solid rgba(255, 255, 255, 0.2)',
                        }, children: !(user === null || user === void 0 ? void 0 : user.picture) && ((_e = (((_c = user === null || user === void 0 ? void 0 : user.given_name) === null || _c === void 0 ? void 0 : _c[0]) || ((_d = user === null || user === void 0 ? void 0 : user.name) === null || _d === void 0 ? void 0 : _d[0]) || 'U')) === null || _e === void 0 ? void 0 : _e.toUpperCase()) }) }) }), _jsx(Popover, { anchorEl: anchorEl, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, open: open, onClose: handleClose, PaperProps: {
                    elevation: 8,
                    sx: {
                        backgroundColor: 'white',
                        borderRadius: 2,
                        overflow: 'visible',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: -8,
                            right: 20,
                            width: 0,
                            height: 0,
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderBottom: '8px solid white',
                            filter: 'drop-shadow(0 -1px 2px rgba(0,0,0,0.1))',
                        },
                    },
                }, children: _jsxs(ProfilePopover, { children: [_jsxs(ProfileHeader, { children: [_jsx(Avatar, { alt: (_f = ((user === null || user === void 0 ? void 0 : user.given_name) || (user === null || user === void 0 ? void 0 : user.name) || 'User')) === null || _f === void 0 ? void 0 : _f.toUpperCase(), src: user === null || user === void 0 ? void 0 : user.picture, sx: { width: 48, height: 48, bgcolor: 'primary.main' }, children: !(user === null || user === void 0 ? void 0 : user.picture) && ((_j = (((_g = user === null || user === void 0 ? void 0 : user.given_name) === null || _g === void 0 ? void 0 : _g[0]) || ((_h = user === null || user === void 0 ? void 0 : user.name) === null || _h === void 0 ? void 0 : _h[0]) || 'U')) === null || _j === void 0 ? void 0 : _j.toUpperCase()) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600, lineHeight: 1.2 }, children: (user === null || user === void 0 ? void 0 : user.given_name) || (user === null || user === void 0 ? void 0 : user.name) || 'User' }), (user === null || user === void 0 ? void 0 : user.email) && (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { lineHeight: 1.2 }, children: user.email }))] })] }), _jsx(Stack, { spacing: 1, children: organization && getSubdomain(organization) && !((_k = getSubdomain(organization)) === null || _k === void 0 ? void 0 : _k.includes("hitwit")) && (_jsxs(ProfileInfo, { children: [_jsx(BusinessIcon, { color: "action", sx: { fontSize: 20 } }), _jsxs(Box, { children: [_jsx(Typography, { variant: "caption", color: "text.secondary", sx: { display: 'block', lineHeight: 1 }, children: "Organization" }), _jsx(Typography, { variant: "body2", sx: { fontWeight: 500 }, children: getSubdomain(organization) })] })] })) }), _jsx(LogoutButton, { variant: "outlined", color: "error", startIcon: _jsx(LogoutIcon, {}), onClick: handleLogout, children: "Sign Out" })] }) })] }));
});
